import { singleValueReducer } from 'store/reducerUtils';
import { setCostCenterFilter } from 'modules/settings/submodules/clients/costCenters/components/Filter/store/actions';

export const costCenterFilter = singleValueReducer(setCostCenterFilter.action, '');
